import { Injectable, Renderer2, RendererFactory2, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

export class FontOptions {
  fontSize?: string;
  fontFamily?: string;
  letterSpacing?: string;
  lineHeight?: string;
}

@Injectable({
  providedIn: 'root',
})
export class StringUtilService {
  private _renderer: Renderer2;
  constructor(
    _rendererFactory: RendererFactory2,
    @Inject(DOCUMENT) private _document: any
  ) {
    this._renderer = _rendererFactory.createRenderer(null, null);
  }

  public getStringWidth(
    str: string,
    fontOptions: string | FontOptions | CSSStyleDeclaration = 'arial 16px'
  ): number {
    const div = this._document.createElement('div');
    div.innerHTML = str;
    this._renderer.setStyle(div, 'white-space', 'nowrap');
    this._setElementCommonStringDimensionStyles(div);
    this._setElementFontOptions(div, fontOptions);
    this._renderer.appendChild(this._document.body, div);
    const width = div.clientWidth;
    this._renderer.removeChild(this._document.body, div);
    return width;
  }

  public getStringHeight(
    str: string,
    widthConstraint: number = 0,
    fontOptions: string | FontOptions | CSSStyleDeclaration = 'arial 16px'
  ) {
    const div = this._document.createElement('div');
    div.innerHTML = str;
    this._renderer.setStyle(div, 'word-wrap', 'break-word');
    this._setElementCommonStringDimensionStyles(div);
    this._setElementFontOptions(div, fontOptions);
    if (widthConstraint) {
      this._renderer.setStyle(div, 'width', `${widthConstraint}px`);
    } else {
      this._renderer.setStyle(div, 'width', `auto`);
    }
    this._renderer.appendChild(this._document.body, div);
    const height = div.clientHeight;
    this._renderer.removeChild(this._document.body, div);
    return height;
  }

  public padLeft(orig: string, len: number, pad: string) {
    return (pad.repeat(len) + orig).slice(-len);
  }

  private _setElementCommonStringDimensionStyles(element: any) {
    this._renderer.setStyle(element, 'margin', '0px');
    this._renderer.setStyle(element, 'padding', '0px');
    this._renderer.setStyle(element, 'position', 'absolute');
    this._renderer.setStyle(element, 'visibility', 'hidden');
  }

  private _setElementFontOptions(
    element: any,
    fontOptions: string | FontOptions | CSSStyleDeclaration
  ) {
    if (typeof fontOptions === 'string') {
      this._renderer.setStyle(element, 'font', fontOptions);
    } else {
      this._renderer.setStyle(element, 'fontFamily', fontOptions.fontFamily);
      this._renderer.setStyle(element, 'fontSize', fontOptions.fontSize);
      this._renderer.setStyle(
        element,
        'letterSpacing',
        fontOptions.letterSpacing
      );
      this._renderer.setStyle(element, 'lineHeight', fontOptions.lineHeight);
    }
  }
}
